var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('DropdownMultiselect',_vm._b({on:{"toggle":_vm.toggleColumn}},'DropdownMultiselect',{ options: _vm.columns, isCustom: _vm.isCustom },false))],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"centered-items"},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fal fa-eye"})]),_c('span',[_vm._v("Properties")])])])
}]

export { render, staticRenderFns }